import { useEffect, useRef, useState } from "react";
import { listaColoresChart } from "../Components/shared/colores";
import * as XLSX from 'xlsx';
import { getDataGrafico } from "../services/service";
import Select from 'react-select';
import NewBarChartDefault from "../Components/highChart/new/NewBarChartDefault";
import html2canvas from "html2canvas";
import { InterfaceGraph } from "../interfaces/InterfaceGraph";


const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        padding: 4,
        fontSize: 11,
    }),
    multiValue: (base: any, state: any) => {
        return { ...base, fontSize: 14 };
    },
    singleValue: (provided: any, state: any) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition };
    }
};

const defaultData = {
    label: '',
    data: [],
    borderColor: '',
    fill: false,
    tension: 0.4,
};


 const MainCP: React.FC<InterfaceGraph> = (props) => {
    const divRef = useRef(null);

    const { idTipoGraficoProps,nameTitleProps,tituloProps='',subtitleProps='',selectValueProsp=[],formatDataStringData='%',disableFilterProps=false,numDecimalProps=0,pieTextProps='',showPieTextInGraph=true,showLineTop=true,showSeries=true,titleY='',mostrarNegativos=false,mostrarlegend=true,showCategory=true,yAxisMax=100,isYAxisActive=true} = props;
    const idTipoGrafico = idTipoGraficoProps;
    const nameTitle = nameTitleProps;

    const [labels, setLabels] = useState([]);
    const [selectOptions, setSelectOptions] = useState([]);
    const [valuesSelected, setValuesSelected] = useState(selectValueProsp);
    const [currentDatasetItem, setCurrentDatasetItem] = useState([]);
    const [arrayColores, setArrayColores] = useState(listaColoresChart);
    const [apiData, setApiData] = useState([]);
    const [auxCount, setAuxCount] = useState(2);

    const onChangeSelect = async (itemsSelected: any) => {
        const values: string[] = itemsSelected.map((item: any) => item.value);
        if (auxCount < values.length) {
            setAuxCount(auxCount + 1);
            setArrayColores([
                ...arrayColores,
                `rgb(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)})`
            ]);
        } else {
            setAuxCount(auxCount - 1);
        }

        setValuesSelected(itemsSelected);
        if (values.length === 0) {
            setCurrentDatasetItem([]);
            return defaultData;
        }
        const updatedItemsDataset: any = [];
        const dataSet = await arrayDataset();
        let datasetItem: any = [];
        values.forEach((val: any) => {
            datasetItem = dataSet.find((item: any) => item.name === val);
            if (datasetItem) {
                updatedItemsDataset.push(datasetItem);
            }
        });
        getLabels(apiData,updatedItemsDataset)
/*
        setCurrentDatasetItem(updatedItemsDataset);
*/
    }

    const arrayDataset = async (data: any = []) => {
        let arrayItem: any = [], auxArrayToUse: any = [];
        auxArrayToUse = data.length === 0 ? apiData : data;
        await auxArrayToUse.reduce(async (waitExcel: any, dataItem: any) => {
            await waitExcel;
            const dataFormat = await settingData(dataItem);
            // console.log(dataFormat, 'dataFormat');
            
            arrayItem.push(dataFormat);
        }, Promise.resolve());
        return arrayItem
    }

    const exportExcel = (params: any) => {
        //Creo un nuevo excel
        const wb = XLSX.utils.book_new();

        //Se setean los datos al formato para el excel
        const data = XLSX.utils.json_to_sheet(setDataGraficoForExcel(apiData));
        
        // console.log('data', data);
    
        //Se crea una pagina por cada cada grafico con sus respectivos datos
        XLSX.utils.book_append_sheet(wb, data, 'Pagina 1');

        //Se descarga el excel
        XLSX.writeFile(wb, "Data " + tituloProps + ".xlsx")
    }

    const setDataGraficoForExcel = (data: any) => {
        let arrayAux: any = [];
        data.map((item: any) => {
            let objAux: any = {};
            for (const key in item) {
                for (const key2 in item[key]) {
                    for (const key3 in item[key][key2]) {
                        let auxObj :any = item[key][key2][key3]
                        if(key3 === nameTitle){
                            objAux['nombre'] = auxObj;
                        } else {
                            objAux["- " + key3.toString() + " -"] = auxObj ? auxObj : '-';
                        }
                    }
                }
            }
            arrayAux.push(objAux);
        });
        const updatedItemsDataset: any = [];
        valuesSelected.forEach((valor: any) => {
            let datasetItem = arrayAux.find((item: any) => item.nombre === valor.value);
            if (datasetItem) {
                updatedItemsDataset.push(datasetItem);
            }
        });
        return updatedItemsDataset;
    }

    const settingData: any = (data: any) => {

        if (data) {
            let response: any = {
                name: '',
                data: []
            };
            let ikey: number = 0
            data.map((item :any) => {
                for (const key in item) {
                    for (const key2 in item[key]) {
                        let auxObj :any = item[key][key2];
                        if(key2 === nameTitle){
                            response.name = auxObj;
                        } else {
                            if(auxObj !== "-"){
                                let num = parseFloat(auxObj);
                                // console.log(num);
                                
                                response.data.push([ikey, num]);
                            }else {
                                response.data.push('-');
                            }
                            ikey++;
                        }
                    }
                }
            });
            // console.log(response, 'response');
            
            return response;
        } else {
            return 'No Data'
        }
    }

    const getLabels: any = (data: any,dataGraficos:any) => {
        let arrayAux: any = [], arrayAux2: any = [];
        data.map((items:any) => {
            items.map((item:any, index:number) => {
                for (const key in item) {
                    let nomKey :string =  Object.keys(item[key])[0];
                    if( nameTitle !== nomKey){
                        arrayAux.push(nomKey)
                    }
                }
            });
        });
        let labels:any = arrayAux.filter((valor:any, indice:number) => {
            return arrayAux.indexOf(valor) === indice;
        });
        // console.log(labels, 'labels');
        
        const dataLabels =labels.filter((label: any,index:any) => {
            let existeValue:boolean = false
            dataGraficos.forEach( (r: any) =>{

                if(mostrarNegativos){
                    // console.log(r.data[index]);
                    
                    if (r.data[index]){
                        existeValue = true
                    }
                }else{
                    // console.log('r.data[index]',r.data[index] );
                    
                    if (r.data[index][1] > 0){
                        // console.log('psao ');
                        
                        existeValue = true
                    }
                }
               
            })

            if (existeValue){
                return label
            }
        })

        let dataGraph = dataGraficos.map( (graph: any) =>{

            let DataGraph= graph.data.filter((valuesData: any,index:any) => {
                if (labels[index]){
// console.log(labels[index]);
// console.log(dataLabels);
// console.log(dataLabels.includes(labels[index]))

                    if (dataLabels.includes(labels[index])){
                        // console.log('ohh',labels[index]);
                        
                        return true

                    }else{
                        return false
                    }
                }

            })
            return {name:graph.name,data:DataGraph}
        })
        // console.log(dataGraph, 'dataGraph');
        // console.log(dataLabels, 'dataLabels');
        
        
        setCurrentDatasetItem(dataGraph)
        setLabels(dataLabels);
    }

    const getOptionsOfSelect = (data :any) => {
        return data.map((item :any) => {
            for (const key in item) {
                for (const key2 in item[key]) {
                    let aux :any = item[key][key2][nameTitle];
                    if(aux !== undefined){
                        return (
                            {
                                label: aux,
                                value: aux
                            }
                        )
                    }
                }
            }
        })
    }

    const handleCapture = () => {
        if (divRef.current) {
          html2canvas(divRef.current).then(canvas => {
            // Generar imagen base64
            const imgData = canvas.toDataURL('image/jpeg');
            // Crear un enlace para descargar la imagen
            const link = document.createElement('a');
            link.download = tituloProps+'.jpeg';
            link.href = imgData;
            link.click();
          });
        }
      };

    useEffect(() => {

        console.log('====================================');
        console.log('Propv',props);
        console.log('====================================');
        getDataGrafico(idTipoGrafico).then(async (response: any) => {
            let { data, status } = response;
            if (parseInt(status) == 200) {
                let apiData: any = data.data.dataGrafico.Hoja1;
                setApiData(apiData);
                let aux: any = [];
                await arrayDataset(apiData).then(async (funcResponse: any) => {
                    await selectValueProsp.map((item: any) => {
                        const auxItem: any = funcResponse.find((element: any) => item.label == element.name);
                        aux.push(auxItem);
                    })
                });
                setSelectOptions(await getOptionsOfSelect(apiData));
/*
                setCurrentDatasetItem(aux);
*/
                await getLabels(apiData,aux);

            } else {
                console.error('Error: ' + status);
            }
        });
    }, []);
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className={`d-flex justify-content-center ${showLineTop?'border-top-graph':''} `} >
            <div className="bg-body rounded chart-content mt-3">
                <div className={disableFilterProps?'d-none':''}>
                <Select
                 className="react-select-container"
                 classNamePrefix="react-select"
                    isMulti
                    placeholder="Seleccionar..."
                    styles={customStyles}
                    closeMenuOnSelect={true}
                    options={selectOptions}
                    onChange={onChangeSelect}
                    value={valuesSelected}
                />
                </div>


                <div ref={divRef} className='mt-3 container-graphLine'>
                    <NewBarChartDefault
                    titleY={titleY}
                    showCategory={showCategory}
                        allData={currentDatasetItem}
                        title={tituloProps}
                        subtitle={subtitleProps}
                        numDecimalProps={numDecimalProps}
                        pieTextProps={pieTextProps}
                        showSeries={showSeries}
                        formatDataStringData={formatDataStringData}
                        showPieTextInGraph={showPieTextInGraph}
                        exportarImagen={handleCapture}
                        labels={labels}
                        colores={arrayColores}
                        exportExcel={exportExcel}
                        activeButton={valuesSelected.length > 0 ? true : false}
                        onChangeSelect={onChangeSelect}
                        mostrarlegend={mostrarlegend}
                        yAxisMax={yAxisMax}
                        isYAxisActive={isYAxisActive}
                    />
                </div>
                <div className='d-flex flex-row-reverse mt-4 newFontSubTitle'>
                    <p style={{ fontSize: 10 }}>{pieTextProps &&!showPieTextInGraph? pieTextProps: ''}</p>
                </div>
            </div>
              {/* <ChartV5 /> */}
            </div>
          </div>
        </div>
      </div>
    )
  }
  
 

  export default MainCP;
  